<template>
  <div class="card"
       :class="cardClasses"
       @click="$emit('click')">
    <div class="card-title">
      <slot name="title" />
    </div>

    <div class="card-content">
      <slot name="content" />
    </div>

    <div v-if="showButton" class="card-edit">
      <component :is="icon"
                 width="18"
                 height="18" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'big'
      },

      widthAuto: {
        type: Boolean,
        default: false
      },

      icon: {
        type: String,
        default: 'IconEdit'
      },

      showButton: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      cardClasses() {
        return [
          `card-size-${this.size}`,
          { 'card-width-auto': this.widthAuto }
        ]
      }
    }
  }
</script>
